<template>
    <app-layout>
        <template #header>
            <FarmTitle :farm="farm">
                Exporte
            </FarmTitle>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white shadow sm:rounded-lg">
                    <div class="px-4 py-5 sm:p-6">
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            Export erstellen
                        </h3>
                        <div class="mt-2 text-sm text-gray-500 w-full">
                            <p class="w-full">-
                                Einen neuen Export für die nächste Abrechnung erstellen. Idr. sollte das Datum der letzte des nächsten Monats sein (also im Januar 2021 dann 28.02.2021)
                            </p>
                        </div>
                        <div class="mt-5 sm:flex sm:items-center">
                            <div class="w-full sm:max-w-xs">
                                <label for="text" class="sr-only">Abbuchungstext</label>
                                <input v-model="createForm.text" type="text" name="text" id="text" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Stallmiete Februar, Services aus Januar 2021" />
                                <input-error :message="createForm.errors.text" />
                            </div>
                            <div class="w-full sm:max-w-xs sm:mt-0 sm:ml-3">
                                <label for="date" class="sr-only">Datum</label>
                                <input v-model="createForm.date" type="date" name="text" id="date" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                <input-error :message="createForm.errors.date" />
                            </div>
                            <button @click="createForm.post(route('farm.export.create', farm))" :disabled="createForm.processing" type="submit" class="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                                Erstellen
                            </button>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col mt-6">
                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead class="bg-gray-50">
                                    <tr>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Export
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Summe
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Pferde
                                        </th>
                                        <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Kunden
                                        </th>
                                        <th scope="col" class="relative px-6 py-3">
                                            <span class="sr-only">Edit</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody class="bg-white divide-y divide-gray-200">
                                    <tr v-for="exportObj in exports_parsed" :key="exportObj.id">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                            {{ new Intl.DateTimeFormat('de-DE', { dateStyle: 'short' }).format(new Date(exportObj.date)) }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            <template v-if="final_loaded">
                                                {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(exportObj.value) }}
                                            </template>
                                            <template v-else>
                                                Lädt...
                                            </template>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            <template v-if="final_loaded">
                                                {{ new Intl.NumberFormat('de-DE', { style: 'decimal' }).format(exportObj.horse_count) }}
                                            </template>
                                            <template v-else>
                                                Lädt...
                                            </template>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            <template v-if="final_loaded">
                                                {{ new Intl.NumberFormat('de-DE', { style: 'decimal' }).format(exportObj.customer_count) }}
                                            </template>
                                            <template v-else>
                                                Lädt...
                                            </template>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium flex flex-row-reverse">
                                            <a :href="route('export.download.excel', exportObj.id)">
                                                <TableIcon class="h-4 w-4 text-gray-400 hover:text-gray-600" />
                                            </a>
                                            <a :href="route('export.download.datev', exportObj.id)">
                                                <DocumentReportIcon class="h-4 w-4 text-gray-400 hover:text-gray-600 mr-2" />
                                            </a>
                                            <label :for="'rsa_upload_download-'+exportObj.id">
                                                <DatabaseIcon class="h-4 w-4 text-gray-400 hover:text-gray-600 mr-2" />
                                            </label>
                                            <input :id="'rsa_upload_download-'+exportObj.id" type="file" class="hidden" @change="decrypt_download" />
                                            <inertia-link :href="route('export.show', exportObj.id)">
                                                <UsersIcon class="h-4 w-4 text-gray-400 hover:text-gray-600 mr-2" />
                                            </inertia-link>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <h3 class="text-lg leading-6 font-medium text-gray-900 mt-5">
                        Bedeutung der Icons
                    </h3>
                    <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
                        <div v-for="item in items" :key="item.name" class="px-4 py-5 bg-primary-100 shadow rounded-lg overflow-hidden sm:p-6">
                            <dt class="text-md font-bold font-medium text-primary-500 truncate text-center">
                                {{ item.desc }}
                            </dt>
                            <dd class="mt-1 text-3xl font-semibold text-primary-700 flex items-center justify-center w-full">
                                <component :is="item.icon" class="h-16 w-16" aria-hidden="true" />
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from "@/Layouts/AppLayout";
    import FarmTitle from "@/Layouts/FarmTitle";
    import { DocumentReportIcon, DatabaseIcon, UsersIcon, TableIcon } from "@heroicons/vue/solid"
    import InputError from "@/Jetstream/InputError";
    import axios from 'axios';

    export default {
        name: "Farm",
        components: {InputError, FarmTitle, AppLayout, DocumentReportIcon, DatabaseIcon, UsersIcon, TableIcon },
        props: ['farm', 'exports', 'last_day_of_next_month', 'text_string'],
        data() {
            return {
                items: [
                    {
                        desc: 'Kundenliste ansehen',
                        icon: UsersIcon,
                    },
                    {
                        desc: 'SEPA-XML herunterladen',
                        icon: DatabaseIcon,
                    },
                    {
                        desc: 'DATEV-Export herunterladen',
                        icon: DocumentReportIcon,
                    },
                    {
                        desc: 'Excel-Tabelle herunterladen',
                        icon: TableIcon,
                    }
                ],
                createForm: this.$inertia.form({
                    text: this.text_string,
                    date: this.last_day_of_next_month
                }),
                exports_parsed: this.exports,
                final_loaded: false
            }
        },
        mounted() {
            axios.get(route('farm.exports.lazy', this.farm))
                .then(x => {
                    this.exports_parsed = x.data;
                    this.final_loaded = true;
                })
        },
        methods: {
            async decrypt_download(event) {
                console.log(event.target.id.split('-').pop())
                var data = new FormData()
                data.append('rsa_key', event.target.files[0] || '')

                await axios.post(route('export.downloadSepa', event.target.id.split('-').pop()), data)
                    .then(x => {
                        if(x.status == 200)
                            return window.open(x.data)
                        return alert("Falscher Key")
                    })
                event.target.value="";
            },
        }
    }
</script>

<style scoped>

</style>
